module.exports = __webpack_public_path__ + "img/guaranteed-irish.3a987ce.svg";